// extracted by mini-css-extract-plugin
export default {"backdrop":"ConfirmationDialog_backdrop__Oietc","modalStack":"ConfirmationDialog_modalStack__RNc7+"};